import Logger from '../logger';

class CartCheckoutEnabler extends HTMLElement {
  #NAME = 'CartCheckoutEnabler';
  #button;
  #zipCode;
  #deliveryDate;
  #zipObserver;
  #dateObserver;
  #dateInput;
  #zipInput;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.#button = this.querySelector('button[name="checkout"]');
    this.#dateInput = this.querySelector('input[name="attributes[deliveryDate]"]');
    this.#zipInput = this.querySelector('input[name="attributes[zipCode]"]');
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#zipCode = localStorage.getItem('zipCode');
    this.#deliveryDate = localStorage.getItem('deliveryDate');
    this.#updateInputs();
    this.#observerZipInput();
    this.#observerDateInput();
  }

  disconnectedCallback() {
    if (this.#zipObserver) {
      this.#zipObserver.disconnect();
      this.#zipObserver = null;
    }
    if (this.#dateObserver) {
      this.#dateObserver.disconnect();
      this.#dateObserver = null;
    }
  }

  #observerZipInput() {
    const div = document.querySelector('[data-zip-code-input-area]');
    if (div) {
      const mutationCallback = (mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            if (!div.clientHeight) {
              setTimeout(() => {
                this.#zipCode = localStorage.getItem('zipCode');
                this.#updateInputs();
              }, 100);
            }
          }
        }
      };
      this.#zipObserver = new MutationObserver(mutationCallback);
      this.#zipObserver.observe(div, { attributes: true });
    }
  }

  #observerDateInput() {
    const div = document.querySelector('[data-calendar-input-area]');
    if (div) {
      const mutationCallback = (mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            if (!div.clientHeight) {
              setTimeout(() => {
                this.#deliveryDate = localStorage.getItem('deliveryDate');
                this.#updateInputs();
              }, 100);
            }
          }
        }
      };
      this.#dateObserver = new MutationObserver(mutationCallback);
      this.#dateObserver.observe(div, { attributes: true });
    }
  }

  #updateInputs() {
    Logger.info(`${this.#NAME} > #updateInputs > enable = ${!!this.#zipCode && !!this.#deliveryDate}`);
    if (this.#zipCode && this.#deliveryDate) {
      this.#dateInput.value = this.#deliveryDate;
      this.#zipInput.value = this.#zipCode;
      this.#button.disabled = false;
    } else {
      this.#button.disabled = true;
    }
  }

  
}

customElements.define('cart-checkout-enabler', CartCheckoutEnabler);